import React, { Component } from 'react'

export default class WorksSconosciutoAllaPorta extends Component {
    render() {
        return (
            <div class="modal" id="workssconosciutoallaporta" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;Uno sconosciuto alla porta&quot; </strong>(racconti): <em>peQuod , 2008.</em><br/> Premio Comisso, finalista Premio Settembrini.<br/></h5>
                               
                        </div>
                                <div class="modal-body p-4" id="result">




                                    <div align="left">


                                        <br/><br/>
                                            Uno sconosciuto alla porta è la nuova raccolta di racconti di Alessandro Tamburini.
                                            La quarta, per essere precisi, a partire dalla sua prova d’esordio, Ultima sera dell’anno, che ce lo fece conoscere vent’anni fa, nel lontano 1988.
                                            E se per onorare un percorso ventennale si riprendono in mano quei libri, e si legge cosa ne è stato scritto, ritornano alla memoria molti nomi,
                                            e tre in particolare: Pier Vittorio Tondelli, Gilberto Severini e Attilio Lolini.
                                            A voler proprio trovare un filo conduttore comune in Uno sconosciuto alla porta,
                                            questo potrebbe essere il difficile mestiere di vivere o, addirittura, sopravvivere.
                                            Perché le cinque storie che lo compongono, accomunate da una solitudine turbata, da una nascosta inquietudine,
                                            partono da personaggi catturati in presa diretta durante un momento cruciale della propria esistenza.
                                            Con una scrittura pulita, attenta a ciò che spesso non si vede, che “rimanda a Cecov” (per citare appunto Lolini),
                                            Tamburini ci porta in labirinti fatti di vecchi ricordi, passioni incontrollate, amori messi sotto spirito: ci racconta
                                            frammenti di un’umanità che si fa amare esponendosi sulla pagina senza difese.
                                            Dall’uomo turbato e confuso dall’avere scoperto di essere oggetto di desiderio di un altro uomo, all’annoiato con
                                            laurea in psicologia che si trasforma in investigatore privato, al tassista frustrato, ossessionato dal “fantasma” della fidanzata,
                                            che si rifugia in un mondo di travisamenti e fantasie. Personaggi che ci rappresentano, che potrebbero essere i nostri vicini oppure
                                            degli sconosciuti appena dietro la porta delle nostre case, anonimi passanti che oscillano tra fallimento e riscatto,
                                            tra rassegnazione e, improvvisa e inaspettata, salvezza.
                                            
                                            
<br/>
                                                <strong>ne hanno scritto:</strong> <br/><br/>

                                                    Alessandro De Bertolini, Corriere della Sera Trentino, 15-5-08 <br/>
                                                        Alessandro Gemovese, L’Adige, 13-5-08 <br/>
                                                            Stefano Fait, Il Trentino, 17-5-08 <br/>
                                                                Elena Fontana, Vita Trentina, 26-6-08 <br/>
                                                                    Alessandra Lochner, UCT  giugno-luglio 08 <br/>
                                                                        Carlo Martinelli, Il Trentino, 22-6-08 <br/>
                                                                            Francesco Roat, L’Adige, 1-7-08 <br/>
                                                                                Roberto Carnero, Famiglia cristiana, 28-8-08 <br/>
                                                                                    Daniela Marcheschi, wwwTeatronaturale.it   settembre 08 <br/>
                                                                                        Giuseppe Amoroso, wwwLunarionuovo.it   agosto 08 <br/>
                                                                                            Roberto Carnero, Sito Scuola Treccani, 14-7-09 <br/>


</div>



                        </div>










                        <div align="center" > 
  <table  cellpadding="0" cellspacing="0" width="500" height="10972">
    <tr> 
      <td width="180" height="10970" align="center"  valign="top" > 
        <table border="0" cellpadding="0" cellspacing="0" height="400">
          <tr height="80"> 
            <td height="80"></td>
          </tr>
          <tr> 
            {/* <td valign="top"><img src="./img/cop/sconosciuto_med.jpg" width="97" height="144" border="0" alt="NO FILE FOUND"></img></td> */}
          </tr>
        </table></td>
      <td width="333" align="center" valign="top" bgcolor="#ffefce"> <table border="0" cellpadding="0" cellspacing="0" width="300">
          <tr height="80"> 
            <td height="80" align="left" valign="middle" nowrap> <div > 
                <h1>Uno sconosciuto alla porta</h1>
              </div>
             </td>
          </tr>
          <tr> 
            <td width="300" height="10770" valign="top"> <div > 
                <div align="justify"> 
                  <p>Alessandro de Bertolini, Corriere della 
                    sera</p>
                  <p>La solitudine &egrave; un lusso solo 
                    per chi se la pu&ograve; permettere. Non per gli anziani, 
                    gli ammalati, gli sconfitti. Ma se in un giorno qualunque 
                    di solitudine, segnato dai binari del ricordo e appeso a un 
                    filo di malinconia, qualcuno irrompe e mescola le carte, pu&ograve; 
                    capitare a volte di ritrovarsi per la mani un colore o un 
                    poker d&#8217;assi. E se alla fine, a carte in tavola, non 
                    &egrave; ancora giunto il gran finale, come se ci si trovasse 
                    orecchie tese ad aspettare il colpo di scena, allora si capisce 
                    come nascono e si sviluppano gli ultimi racconti di Alessandro 
                    Tamburini, pubblicati nella raccolta <em>Uno sconosciuto alla 
                    porta</em> appena edita per peQuod. Niente a che vedere, per&ograve;, 
                    con una partita a carte, perch&eacute; la posta in palio sono 
                    i sentimenti e le passioni, gli animi, gli affetti e quello 
                    spaccato di umanit&agrave; che l&#8217;autore trentino mette 
                    in mostra andandolo a pescare nel cilindro degli incontri 
                    tra sconosciuti. Uno sconosciuto bussa alla porta, appunto, 
                    e via con le magie d&#8217;autore dove Tamburini svela il 
                    detto e il non detto dei rapporti umani, l&#8217;improvviso 
                    e il consueto, il groviglio dei ricordi e l&#8217;incomprensibile 
                    del presente. Se un modello deve esserci, ci si chiede, che 
                    sia Cechov. &#8220;Ecco, s&igrave;. Forse &egrave; proprio 
                    Cechov&#8221;, dice Tamburini. Anzi no, &#8220;forse non c&#8217;&egrave; 
                    un modello preciso a cui mi ispiro n&eacute; a cui sono ispirati 
                    questi racconti&#8221;. Il bello, tra le pagine di Tamburini, 
                    &egrave; che sono il detto e il non detto a dialogare fra 
                    di loro. L&#8217;autore scrive. Ed &egrave; bravissimo se 
                    nel raccontare fa emergere l&#8217;aria che si respira dentro 
                    un racconto o dentro un romanzo ma lo &egrave; ancora di pi&ugrave; 
                    &#8211; e non c&#8217;&egrave; contraddizione &#8211; quando 
                    riesce a dire le cose senza scriverle. Insomma, se riesce 
                    a farle respirare dalla parte di chi legge. Cos&igrave;, Tamburini 
                    ci dice e non ci dice, scrive e non scrive, bussando alla 
                    porta dei sentimenti di una umanit&agrave; che tanto ci somiglia. 
                    Noi, invece, abbiamo detto tutto. Tutti gli elementi che i 
                    racconti del libro hanno in comune e il loro comune denominatore. 
                    La solitudine, la solitudine turbata, l&#8217;elemento di 
                    attesa e di suspance e il rapporto umano che si instaura fra 
                    sconosciuti. Resta da occuparsi, ancora, dell&#8217;aspetto 
                    autobiografico. Cio&egrave;, sono cos&igrave; pochi quei racconti 
                    o quei romanzi che non si basano, almeno in parte, su esperienze 
                    autobiografiche, che ci si domanda dove e quanto anche Tamburini 
                    abbia messo mano ai suoi ricordi per scrivere le storie. Al 
                    contrario, nulla di tutto questo. &#8220;I racconti del libro 
                    &#8211; spiega &#8211; nascono fuori dal mio vissuto. Forse, 
                    i miei ricordi sono stati la scintilla. Ma le storie sono 
                    inventate&#8221;. Ma come si inventano storie cos&igrave;? 
                    &#8220;Ho avuto la sensazione &#8211; aggiunge &#8211; che 
                    ci fossero gi&agrave; dentro di me. Non &egrave; facile spiegare. 
                    &Egrave; stato un po&#8217; come accingere a una miniera, 
                    un piccolo giacimento che si &egrave; poi esaurito&#8221;. 
                    Esaurito? &#8220;S&igrave;, dopo avere scritto l&#8217;ultimo 
                    dei cinque racconti mi sono accorto che non ce ne erano altri. 
                    Che avevo finito l&igrave;&#8221;. Ecco, i racconti sono cinque 
                    in tutto. E, quanto appena detto, &egrave; la storia di Alessandro 
                    Tamburini autore di Uno sconosciuto alla porta e di Alessandro 
                    Tamburini scrittore di quattro raccolte di racconti e cinque 
                    romanzi. &#8220;Sono queste &#8211; dice &#8211; le due forme 
                    narrative di cui mi sono innamorato&#8221;.</p>
                  <p>&nbsp;</p>
                  <p>Alessandro Genovese, Adige</p>
                  <p>A due anni esatti dall&#8217;uscita 
                    del suo ultimo, fortunato romanzo, <em>Bagaglio leggero</em>, 
                    Alessandro Tamburini torna in libreria, questa volta con una 
                    raccolta di racconti intitolata <em>Uno sconosciuto alla porta</em>. 
                    Ne parliamo con l&#8217;autore.<br/>
                    <em>Qual &egrave; stato lo spunto che ha dato il via a questo 
                    nuovo libro?</em><br/>
                    Il mio esordio nella narrativa, che risale a ormai vent&#8217;anni 
                    fa, fu proprio con una raccolta di racconti, <em>Ultima sera 
                    dell&#8217;anno</em>. E anche da quando ho cominciato a scrivere 
                    e a pubblicare romanzi, non ho mai smesso di dedicarmi ai 
                    racconti. In questo caso, a un certo punto mi sono accorto 
                    che stavo scrivendo dei racconti con dei tratti comuni. La 
                    gestazione di questo libro, quindi, &egrave; stata molto simile 
                    a quella di un romanzo.<br/>
                    <em>Quali sono questi tratti comuni?</em><br/>
                    Mentre nei miei racconti precedenti le storie erano spesso 
                    fondate su rapporti radicati profondi, di amicizia, di parentela 
                    o sentimentali, qui le storie hanno per protagonisti degli 
                    estranei, persone che non si conoscevano prima e che non resteranno 
                    in rapporto dopo. Al centro di tutti questi racconti c&#8217;&egrave; 
                    quindi un incontro tra sconosciuti, che per qualche circostanza 
                    si incontrano e vivono esperienze comuni e intense. In questo 
                    senso, il titolo della raccolta &egrave; indicativo: &egrave; 
                    quello di uno dei racconti, ma potrebbe valere per tutti, 
                    esprime uno stato d&#8217;animo che li accomuna tutti.<br/>
                    <em>A proposito del titolo, a prima vista potrebbe sembrare 
                    quello di un libro giallo, di suspense&#8230;</em><br/>
                    In effetti questo &egrave; l&#8217;altro carattere che lega 
                    i cinque racconti presenti nel libro, che senza essere di 
                    genere hanno per&ograve; qualcosa a che vedere, se non con 
                    il giallo, quantomeno con la suspense. Parlerei di &#8220;giallo 
                    esistenziale&#8221;: ciascuno dei protagonisti, a un certo 
                    punto, si trova in un momento critico, di sospensione, di 
                    incertezza, di attesa e mistero, che si risolve poi in un 
                    momento di rivelazione, di spiazzamento.<br/>
                    <em>Mi viene in mente quel che diceva Raymond Carver: &laquo;Mi 
                    piace quando in un racconto aleggia un senso di minaccia&raquo;.</em><br/>
                    &Egrave; una frase in cui mi riconosco completamente. Queste 
                    mie storie sono tutte caratterizzate da una tensione implosa, 
                    sospesa, che poi deflagra con una sorta di liberazione. A 
                    me piacerebbe, come accade appunto nel giallo, che anche il 
                    lettore si trovasse in uno stato di tensione e di attesa.<em><br/>
                    Dal punto di vista editoriale, per&ograve;, la scelta di pubblicare 
                    dei racconti &egrave; senz&#8217;altro coraggiosa.</em><br/>
                    Si sa che il mercato editoriale &egrave; ostico verso i racconti. 
                    E non si capisce se questa ritrosia degli editori sia suffragata 
                    da una ritrosia dei lettori, o non sia solo una cattiva abitudine 
                    italiana. Negli Stati Uniti, per esempio, il racconto ha una 
                    cittadinanza e una dignit&agrave; pari a quella del romanzo. 
                    Personalmente ritengo che il racconto sia una forma compiuta 
                    quanto il romanzo, e il merito della casa editrice Pequod 
                    &egrave; di aver sempre dato molto spazio ai libri di racconti, 
                    che occupano pi&ugrave; della met&agrave; dei titoli in catalogo. 
                    E poi non dimentichiamo che la tradizione italiana &egrave; 
                    ricca di racconti, e molti importanti autori italiani ne hanno 
                    scritto di esemplari. Penso a Fenoglio, Bilenchi, Landolfi, 
                    Parise o Silvio D&#8217;Arzo, autore di quello che forse considero 
                    il mio racconto preferito, <em>Casa D&#8217;altri</em>, purtroppo 
                    poco conosciuto.<br/>
                    <em>Una grande autrice di racconti, la canadese Alice Munro, 
                    in un suo racconto che vede per protagonista una scrittrice, 
                    a un certo punto le fa dire: &laquo;mi accorsi che il lavoro 
                    a cui volevo dedicarmi era pi&ugrave; simile a una mano che 
                    acciuffi qualcosa nell&#8217;aria che alla costruzione di 
                    storie&raquo;. Concorda?</em><br/>
                    S&igrave;, nel senso che credo che sia insito nella forma 
                    racconto qualcosa di meno sistematico rispetto al romanzo. 
                    Il racconto ha a che fare con lo sguardo di un testimone, 
                    secondo un punto di vista limitato e in un&#8217;unit&agrave; 
                    di tempo pi&ugrave; ridotta. Quello che il romanzo acquista 
                    per estensione il racconto deve acquistarlo per densit&agrave; 
                    e profondit&agrave;.<br/>
                    <em>Dopo questo libro pensa di tornare al romanzo?</em><br/>
                    In effetti sto lavorando da mesi alla stesura di un nuovo 
                    romanzo.<br/>
                    <em>Ci pu&ograve; dare qualche anticipazione?</em><br/>
                    Diciamo che ha a che vedere con il tema dell&#8217;immigrazione 
                    clandestina.<br/>
                    <em>Un tema attuale e scottante, specie di questi tempi&#8230; 
                    Pensa che la politica stia dando le risposte giuste a quello 
                    che da molti cittadini &egrave; percepito come un problema?</em><br/>
                    Credo di no. Come tanti altri temi scottanti della nostra 
                    contemporaneit&agrave;, anche questo viene trattato con uno 
                    strano miscuglio di quotidiana tragedia alla quale corrisponde 
                    una progressiva assuefazione, che rischia di portare a un&#8217;inesorabile 
                    indifferenza.<br/>
                    <em>Secondo Lei la letteratura pu&ograve; dare risposte? E 
                    se s&igrave;, quali?</em><br/>
                    Ho sempre pensato che la narrativa possa dare risposte pi&ugrave; 
                    penetranti della politica. Mi spiego meglio: se davanti a 
                    una sequenza di notizie tragiche dei telegiornali la reazione 
                    pu&ograve; essere quella di scuotere la testa con un misto 
                    di sdegno e di fatalismo, una pagina di letteratura, quando 
                    funziona, pu&ograve; produrre risultati pi&ugrave; pervasivi 
                    e meno effimeri. </p>
                  <p><br/>
                    ALESSANDRO TAMBURINI SI RACCONTA</p>
                  <p>Alessandra Lochner, UCT: Uomo, citt&agrave;, 
                    territorio SERIE - GLI SCRITTORI TRENTINI</p>
                  <p>A vent&#8217;anni dal suo ingresso 
                    nella narrativa italiana con <em>Ultima sera dell&#8217;anno</em>, 
                    lo scrittore Alessandro Tamburini ritorna al forma del racconto 
                    con l&#8217;ultimo libro <em>Uno sconosciuto alla porta</em>, 
                    da poco uscito in librerie per le edizioni peQuod, di Ancona. 
                    E in questa occasione stende un bilancio complessivo del suo 
                    percorso letterario, del suo rapporto con la scrittura, con 
                    la memoria e con le storie.<br/>
                    <em>Come nasce l&#8217;esigenza di affidare alla scrittura 
                    le proprie storie?</em><br/>
                    Per un lungo periodo mi ha colpito una frase scritta da uno 
                    scrittore svizzero di lingua tedesca, Peter Bichsel, che diceva 
                    &laquo;Lo stato d&#8217;animo da cui nascono le storie &egrave; 
                    la tristezza di fronte alla caducit&agrave; delle cose della 
                    vita&raquo;. Si scrive per fermare qualcosa, per sottrarlo 
                    all&#8217;oblio. Penso poi di aver avuto dei motivi personali 
                    che mi hanno incentivato alla scrittura. Quando ero piccolo 
                    ho cambiato molte volte citt&agrave; e quando mi presentavo 
                    nella nuova scuola, o nel nuovo cortile, spesso mi sentivo 
                    chiedere: &#8220;Tu da dove vieni? Chi sei?&#8221;. Domande 
                    che si fanno solo a chi viene da fuori. Credo che questo mi 
                    abbia stimolato, mi abbia abituato a raccontare la mia storia, 
                    perch&eacute; mi chiedevano di farlo, perch&eacute; ero uno 
                    straniero. Cos&igrave; &egrave; cominciata l&#8217;attenzione 
                    per i fatti, le storie, la scrittura.<br/>
                    <em>Quale funzione attribuisci alla tua scrittura?</em><br/>
                    Io scrivo da ormai 25 anni e in questo tempo per me la funzione 
                    della scrittura &egrave; cambiata, non &egrave; sempre rimasta 
                    la stessa. Quando ho cominciato mi ha spinto probabilmente 
                    un intento di imitazione. Amavo molto dei libri e ho cominciato 
                    ad avere questa presunzione, questa ambizione di scriverne 
                    anch&#8217;io. Oggi a distanza di 25 anni la scrittura &egrave; 
                    un vizio, un&#8217;abitudine, un abito mentale.<br/>
                    <em>Qual &egrave; il confine tra realt&agrave; e immaginazione? 
                    E che ruolo ha la realt&agrave; dell&#8217;autore nelle sue 
                    storie? </em><br/>
                    &Egrave; un rapporto alchemico, imprevedibile, sempre cangiante. 
                    Ci sono state circostanze in cui la realt&agrave; entrava 
                    direttamente nella pagina. A volte ho scritto delle storie 
                    vere, anche se la scrittura reinventa sempre. Altre volte 
                    invece ho scritto storie completamente inventate, che nulla 
                    avevano a che fare con la realt&agrave; che mi apparteneva, 
                    e poi ci sono tutte le infinite vie di mezzo, le infinite 
                    possibilit&agrave; intermedie fra questi due poli estremi. 
                    Io per&ograve; non ho una visione dell&#8217;esistenza che 
                    esprimo attraverso la scrittura. Scrivo e forse poi da quello 
                    che ho scritto si pu&ograve; pensare di ricavare una mia qualche 
                    visione dell&#8217;esistenza. In questo senso non sono assolutamente 
                    uno scrittore tematico, cio&egrave; non scrivo per esprimere 
                    deliberatamente una visione del mondo.<br/>
                    <em>Cosa spinge uno scrittore a orientarsi su certe storie, 
                    su certi mondi? </em><br/>
                    La scelta delle storie &egrave; un procedimento assolutamente 
                    non spiegabile e comprensibile dal punto di vista razionale, 
                    e guai se non fosse cos&igrave;. Io non so perch&eacute; a 
                    un certo punto un&#8217;idea, una traccia, mi si fissa in 
                    mente, mi fa pensare a una storia, mi rende necessario scriverla. 
                    Ci sono autori che hanno scritto cose molto belle su questo, 
                    penso a Marino Moretti, a Emilio Cecchi. Mi interessa per 
                    esempio usare il termine &#8220;indizio&#8221;. A volte le 
                    storie si manifestano in forma di indizi, come se la storia 
                    esistesse gi&agrave; e si manifestasse con un segno che ti 
                    consente di svelarla. <br/>
                    <em>Per&ograve; ogni scrittore ha un suo mondo di riferimento, 
                    un inventario di storie possibili&#8230;</em><br/>
                    Ancora una volta, non come intento programmatico, ma come 
                    constatazione di quello che ho fatto, posso dire di avere 
                    una certa predilezione per storie di vita quotidiana, imperniate 
                    sul mistero, le sorprese e le magie che possono scaturire 
                    dalla realt&agrave; di ogni giorno. Questo vale ad esempio 
                    per molti miei racconti, per&ograve; ho anche battuto strade 
                    diverse. Ho scritto due romanzi, <em>L&#8217;onore delle armi</em> 
                    e <em>Bagaglio leggero</em>, in cui invece ho sconfinato su 
                    un piano storico, mettendo in piedi anche scenari ampi. Pi&ugrave; 
                    che un&#8217;identit&agrave; specifica riguardo alla tipologia 
                    delle storie credo di aver mostrato una maggiore continuit&agrave; 
                    nel modo di scrivere, che &egrave; rimasto pi&ugrave; fedele 
                    a un&#8217;idea, a una modalit&agrave; di scrittura piana, 
                    rigorosa, pulita, che rifugge da sperimentalismi, e cerca 
                    soprattutto il nitore espressivo. <br/>
                    <em>Con la pubblicazione di Uno sconosciuto alla porta, il 
                    tuo ottavo libro e il quarto di racconti raggiungi un pareggio 
                    tra romanzi e raccolte di racconti pubblicati&#8230; Perch&eacute; 
                    oggi uno scrittore scrive racconti?</em><br/>
                    Ho sempre amato scrivere sia romanzi che racconti. I racconti 
                    li scrivo sempre e di tanto in tanto scrivo un romanzo. Molti 
                    racconti sono entit&agrave; a s&eacute; stanti e invece altri 
                    si legano tra di loro, come nel caso di questo mio ultimo 
                    libro e allora viene fuori una raccolta di racconti. Succede 
                    a volte di avere un&#8217;idea e di non capire subito se sar&agrave; 
                    un racconto o un romanzo, e solo scrivendo si trova la risposta. 
                    Il racconto ha comunque delle specificit&agrave;, per esempio 
                    lo sguardo del testimone, o una prospettiva temporale limitata. 
                    <br/>
                    <em>Quindi nel racconto c&#8217;&egrave; una dimensione pi&ugrave; 
                    intima?</em><br/>
                    Direi forse uno sguardo pi&ugrave; interno alla narrazione. 
                    Si potrebbe paragonare il romanzo a una sinfonia d&#8217;orchestra 
                    e i racconti alla musica da camera, di per s&eacute; pi&ugrave; 
                    intima, pi&ugrave; raccolta, pi&ugrave; contenuta, anche nella 
                    fruizione. Un racconto pu&ograve; essere per esempio scritto 
                    d&#8217;un fiato dallo scrittore, cosa che per un romanzo 
                    &egrave; inconcepibile. Un racconto pu&ograve; essere letto 
                    d&#8217;un fiato dal lettore, mentre &egrave; pi&ugrave; difficile 
                    per un romanzo, sebbene questo naturalmente &egrave; l&#8217;auspicio 
                    di ogni scrittore: che il lettore lo cominci e non possa staccarsene 
                    finch&eacute; non &egrave; finito, ma questo nella vita di 
                    oggi &egrave; piuttosto difficile.<br/>
                    <em>Qual &egrave; il filo conduttore che lega i racconti di 
                    quest&#8217;ultimo libro?</em><br/>
                    Una volta ricordo che Maria Corti diceva che da una raccolta 
                    di racconti lei si aspettava qualche cosa che fosse di pi&ugrave; 
                    della somma dei singoli racconti che la componevano. Questo 
                    mi sembra molto importante. Ci sono diversi elementi che uniscono 
                    questi racconti. Innanzi tutto un elemento di suspense. Senza 
                    evocare il genere vero e proprio, si potrebbero definire questi 
                    racconti dei gialli esistenziali, delle storie in cui aleggia 
                    un certo mistero, un senso di minaccia. Un secondo elemento 
                    &egrave; dato dal fatto che i protagonisti di questi racconti 
                    sono estranei l&#8217;uno all&#8217;altro fino a un momento 
                    prima che la storia abbia inizio. Sono persone che non hanno 
                    un retroterra comune e questo &egrave; molto rilevante dal 
                    punto di vista narrativo. &Egrave; molto diverso scrivere 
                    una storia di due fratelli o di due persone che si incontrano 
                    per la prima volta, perch&eacute; se parli di due fratelli, 
                    ogni cosa che loro si diranno rimander&agrave; a dei mondi 
                    vissuti, a degli orizzonti temporali profondi, con una quantit&agrave; 
                    di implicazioni. Due estranei che parlano invece rimandano 
                    a un orizzonte completamente differente. <br/>
                    <em>Se devo pensare al tuo percorso, potrei dire che nonostante 
                    un substrato di coordinate letterarie e storiche, nei tuoi 
                    lavori vi &egrave; sempre una componente di &#8220;sperimentalismo&#8221;, 
                    dallo scegliere protagonisti di et&agrave; molto differenti, 
                    da bambini a adolescenti, a uomini, fino agli anziani, passando 
                    per il sesso maschile a quello femminile, o dal mescolare 
                    piani storici differenti, o ambientazioni, fino a stili differenti. 
                    &Egrave; come se mettessi alla prova le potenzialit&agrave; 
                    della tua scrittura&#8230;</em><br/>
                    Non parlerei di sperimentalismo, perch&eacute; per quanto 
                    riguarda le forme narrative io sono sempre stato molto rispettoso 
                    dei canoni del romanzo, del racconto. Per&ograve; &egrave; 
                    vero che ho sperimentato personaggi e et&agrave; diverse. 
                    Ho scritto per esempio molte storie legate al mondo degli 
                    anziani. Allo stesso tempo ho scritto molte storie, soprattutto 
                    nei primi anni del mio lavoro, legate all&#8217;et&agrave; 
                    dell&#8217;adolescenza, della giovinezza, perch&eacute; come 
                    insegnava Bilenchi, l&#8217;et&agrave; della formazione dell&#8217;identit&agrave; 
                    &egrave; molto ricca anche per la narrazione. Il problema 
                    &egrave; che il narratore ha un universo percettivo legato 
                    alla sua et&agrave;, ma deve poi avere la sensibilit&agrave; 
                    e l&#8217;immaginazione necessarie a portarsi dentro universi 
                    percettivi che sono magari molto lontani da lui. &Egrave; 
                    fondamentale questa capacit&agrave; di immedesimazione.<br/>
                    <em>Si pu&ograve; dire che tu sia un autore contemporaneo 
                    a tutti gli effetti, non solo perch&eacute; vivi in quest&#8217;epoca 
                    ma perch&eacute; le storie che racconti sono radicate in questi 
                    anni, anche se le ragioni delle tue storie a volte ti fanno 
                    guardare al passato da cui deriva il presente, creando una 
                    dimensione che vive nella memoria e nel ricordo. Cosa t&#8217;interessa 
                    mettere in luce tra il rapporto tra passato e presente?</em><br/>
                    A questo riguardo, il romanzo <em>L&#8217;onore delle armi 
                    </em>ha segnato un passaggio molto preciso nel mio percorso 
                    narrativo. Avevo scritto i miei primi libri con un orizzonte 
                    marcatamente generazionale, in cui le vicende riguardavano 
                    giovani che avevano pi&ugrave; meno la mia et&agrave;, nei 
                    quali mi rispecchiavo. A un certo punto ho avuto l&#8217;impressione 
                    di aver consumato l&#8217;universo di appartenenza della mia 
                    generazione e ho avuto bisogno di rompere questo che era diventato 
                    una specie di recinto, per andare indietro nel tempo in un 
                    confronto generazionale tra padri e figli. Non a caso, credo, 
                    questo mi &egrave; successo quando sono diventato padre. Ho 
                    riscoperto allora il rapporto con mio padre, che peraltro 
                    era defunto da svariati decenni e ho avuto bisogno di andare 
                    a riscoprire la dimensione della generazione di mio padre, 
                    ho scritto <em>L&#8217;onore delle armi</em> su questo. <br/>
                    <em>Cosa succede nella mente di uno scrittore quando &egrave; 
                    alle prese con un libro e in qualche modo cercare di sapere 
                    quale lavoro si nasconde dietro un&#8217;opera?</em><br/>
                    Possiamo dire che c&#8217;&egrave; una bella differenza fra 
                    il racconto e il romanzo. Per scrivere un romanzo, dai primi 
                    appunti alla prima stesura, fino alle varie riscritture e 
                    revisioni, a me occorrono anni. In questo arco di tempo, la 
                    scrittura arriva a prendere tantissimo dalla vita. Come diceva 
                    Tondelli, c&#8217;&egrave; un modo di essere prensile della 
                    scrittura, per cui tantissimo di quello che vivi finisce dentro 
                    al romanzo nel quale si depositano un&#8217;infinit&agrave; 
                    cose. Il racconto invece si svolge in un tempo molto pi&ugrave; 
                    breve e ha una gestazione differente, molto pi&ugrave; unitaria 
                    e compatta. Mi piace giocare sulla metafora del fiume e del 
                    mare. Scrivere un racconto &egrave; come attraversare un fiume: 
                    non perdi mai di vista la sponda da cui sei partito n&eacute; 
                    quella a cui vuoi arrivare. Un romanzo invece &egrave; come 
                    un mare in cui a un certo punto non vedi pi&ugrave; da dove 
                    sei partito e non vedi ancora l&#8217;approdo, e navighi per 
                    molto tempo cercando una rotta, cercando di capire dove stai 
                    andando e se la direzione &egrave; giusta. Poi per quanto 
                    riguarda quello che succede a uno scrittore, ho un modo di 
                    vivere il mio rapporto con la scrittura intenso e quotidiano. 
                    Alterno varie attivit&agrave; nella mia vita, faccio l&#8217;insegnante, 
                    scrivo di narrativa, ma anche per la televisione, per il cinema, 
                    per i giornali, lavoro nelle biblioteche, faccio tante cose, 
                    per&ograve; ho dei periodi in cui entro interamente nella 
                    scrittura e quindi lavoro tutto il giorno perch&eacute; la 
                    mia mente non si stacca mai dalla storia che sto scrivendo. 
                    Un&#8217;altra mia caratteristica &egrave; che ho un processo 
                    di revisione molto intenso su quello che scrivo, un mio romanzo 
                    pu&ograve; uscire da sette stesure, come &egrave; stato nel 
                    caso de <em>L&#8217;onore delle armi</em>.<br/>
                    <em>E cosa accade in uno scrittore quando un lavoro &egrave; 
                    giunto al temine? Al momento di consegnarlo a un editore?</em><br/>
                    Quando ho finito un libro soffro un po&#8217; di horror vacui 
                    e non per caso nel momento in cui viene stampato sto gi&agrave; 
                    lavorando a un altro libro. Forse proprio perch&eacute; c&#8217;&egrave; 
                    una costante insoddisfazione. Si vorrebbe sempre scrivere 
                    il Libro, ed &egrave; sempre il prossimo, quello ancora da 
                    scrivere, il pi&ugrave; importante.<br/>
                    <em>Ci puoi dire qualcosa del mercato librario di come si 
                    stanno evolvendo le cose? </em><br/>
                    Innanzi tutto l&#8217;Italia &egrave; un Paese molto mal messo 
                    da questo punto di vista. Il fatturato editoriale della narrativa, 
                    specie quella italiana, &egrave; molto limitato. Gli editori 


                    cercano il best seller, il titolo che da solo gli salva il 
                    bilancio di un anno e fanno scelte sempre pi&ugrave; dettate 
                    da motivi solamente commerciali. &Egrave; sempre stato cos&igrave;, 
                    ma negli ultimi anni il processo si &egrave; accentuato. Io 
                    ho avuto dei problemi col mio penultimo libro, Bagaglio leggero, 
                    perch&eacute; &egrave; ambientato in un ospizio per anziani 
                    e questa cosa ha suscitato dei timori di scarsa vendibilit&agrave; 
                    da parte dell&#8217;ufficio commerciale dei grandi editori. 
                    Del resto io non ho nulla di cui lamentarmi perch&eacute; 
                    comunque da quando ho cominciato a scrivere ho sempre pubblicato 
                    in maniera soddisfacente le cose che ho scritto.<br/>
                    <em>Quali sono, se ci sono, gli autori che per l&#8217;uso 
                    della lingua o per la scelta delle storie ti hanno influenzato?</em><br/>
                    Ho amato alcuni scrittori e penso che questi mi abbiano influenzato. 
                    Tra questi ho gi&agrave; citato Romano Bilenchi, proprio per 
                    lo straordinario nitore della sua scrittura che mi ha ispirato, 
                    per&ograve; mi ha ispirato molto anche la lettura della narrativa 
                    americana, con autori come Carver, per quanto riguarda la 
                    ricerca dell&#8217;essenzialit&agrave; e dell&#8217;oggettivit&agrave;. 
                    Sicuramente io non scriverei come scrivo se non avessi letto 
                    e amato cos&igrave; tanto Beppe Fenoglio per esempio. Poi 
                    sono anche figlio di una tradizione emiliana che va da Guareschi 
                    a Celati.<br/>
                    <em>Puoi dirci come vivi la dimensione dell&#8217;impegno 
                    civile nel tuo lavoro?</em><br/>
                    &Egrave; impossibile parlare di impegno civile senza fare 
                    un po&#8217; di retrospettiva, diciamo cos&igrave;. Ho vissuto 
                    quello che io consideravo l&#8217;impegno civile con una forte 
                    partecipazione alla vita sociale e politica del mondo che 
                    mi circondava quando ero ragazzo, per almeno un decennio. 
                    Successivamente l&#8217;esito di quelle esperienze mi ha portato 
                    invece a una dimensione pi&ugrave; privata e appartata. Credo 
                    che per uno scrittore l&#8217;impegno civile sia quello di 
                    scrivere e di assumersi questa responsabilit&agrave;. Pubblicare 
                    dei libri che vengono letti significa comunque dire una qualcosa 
                    sul mondo che ti circonda e che sottintende, implica anche 
                    una visione morale, civile, politica persino, di tutto quello 
                    che ci circonda. Io poi oltre che scrittore sono anche insegnante, 
                    e poi mi considero anche una sorta di militante della letteratura, 
                    perch&eacute; ho condotto tante iniziative nelle biblioteche, 
                    incontri, conferenze, gruppi di lettura. Quindi per me l&#8217;impegno 
                    civile &egrave; anche quello di presumere, fino a quando continuo 
                    a crederlo, che la cultura sia uno dei migliori antidoti contro 
                    il razzismo, la violenza, la discriminazione, la volgarit&agrave; 
                    e tanti mali che affliggono il nostro mondo. L&#8217;impegno 
                    civile &egrave; anche pensare che insegnare a leggere e ad 
                    amare i libri possa essere un modo per educare le persone 
                    e forse contribuire a renderle migliori.</p>
                  <p>&nbsp;</p>
                  <p>ALLA PORTA, VENT'ANNI DOPO</p>
                  <p>Carlo Martinelli, Il Trentino<br/>
                    <br/>
                    Vent&#8217;anni dopo. La stessa febbrile emozione nello scorrere 
                    le pagine. Non perch&eacute; ci fosse chiss&agrave; quale 
                    giallo da risolvere o chiss&agrave; quale avventura da concludere. 
                    Piuttosto perch&eacute; quelle storie, quei racconti delicati, 
                    quel sommesso narrare dentro gli umani accadimenti e attraverso 
                    quegli scarti del tempo che &#8211; uno sull&#8217;altro &#8211; 
                    sono poi la somma dei nostri giorni che scorrono, ecco, tutte 
                    queste cose assieme meritano il naturale approdo di una lettura 
                    appagata. S&igrave;. Vent&#8217;anni dopo Alessandro Tamburini 
                    &#8211; &egrave; questo il nostro personalissimo parere &#8211; 
                    torna prepotentemente l&agrave; dove aveva iniziato. Vent&#8217;anni 
                    fa una raccolta di racconti &#8211; <em>Ultima sera dell&#8217;anno</em>, 
                    pubblicata dal Lavoro editoriale di Massimo Canalini, mai 
                    abbastanza benemerito per quel che ha fatto per la giovane 
                    letteratura di casa nostra &#8211; lanciava Alessandro Tamburini, 
                    insegnante che da una vita ha messo radici a Trento, nel panorama 
                    che conta della letteratura nazionale. In vent&#8217;anni 
                    avrebbe collezionato altre due raccolte di racconti e quattro 
                    romanzi (Marsilio, Bompiani e Pequod gli editori, mica bruscolini). 
                    <br/>
                    Una voce importante, insomma, quella di Tamburini. La conferma 
                    con <em>Uno sconosciuto alla porta</em> (Pequod edizioni, 
                    160 pagine, 16 euro), cinque racconti che sembrano scritti 
                    apposta per essere letti in controluce, quasi dovessero svelarci, 
                    anche, dietro il bianco delle pagine e il nero dei caratteri 
                    che le abitano, una sorta di film animato. S&igrave;: sembra 
                    davvero di vederlo, dietro la porta, il tipo che suona al 
                    campanello di una vecchietta, al paese che sta al confine 
                    tra Italia ed Austria. Lui era sul treno, &egrave; sceso per 
                    una sigaretta, il treno &egrave; ripartito, non ha fatto a 
                    tempo a risalire. E cos&igrave;, intirizzito, nel cuore della 
                    notte, alla ricerca di un posto caldo, finisce davanti ad 
                    un condominio popolare e suona un campanello, a caso. &Egrave; 
                    l&#8217;incipit di un racconto, Brennero, che non si lascia 
                    scordare facilmente. Il primo dei ritratti delicati, eppure 
                    cos&igrave; intimamente veri &#8211; della verit&agrave; che 
                    abita questo nostro tempo incerto ed instabile, precario e 
                    solitario, cui tuttavia restare aggrappati con tenace ostinazione 
                    perch&eacute; &#8220;se questo mondo vi fa schifo, non avete 
                    visto gli altri&#8221;&#8230; - che Tamburini offre al lettore. 
                    Sono racconti dolenti che non rinunciano tuttavia alla speranza 
                    e che potrebbero venire dalla provincia americana, da certi 
                    paesoni della Bretagna, dalle anonime periferie delle citt&agrave; 
                    dell&#8217;Est Europa. Ed invece, a confermare che la buona 
                    letteratura non ha confini e non conosce bandiere giacch&eacute; 
                    racconta di uomini e di donne nel corso del tempo &#8211; 
                    come in un film di Wenders, appunto &#8211; quelli di Tamburini 
                    sono racconti di casa nostra. Sempre sorprendenti, ma di quelle 
                    sorprese mai eccessive, sempre possibili, che magari ti fanno 
                    trasalire, mai sconvolgere. Una inquietudine sottile, amori 
                    che si spezzano (&#8220;le storie d&#8217;amore non possono 
                    finire bene, se no non finirebbero&#8221; scrive Tamburini), 
                    notti da far passare, vicini di casa che non sai mai come 
                    prendere. E poi, ancora: un tipo che si improvvisa investigatore 
                    privato, un tassista che non riesce a scordare il perduto 
                    amor, una macchina usata venduta grazie ad un annuncio su 
                    un giornale e che innesca una vicenda surreale, destinata 
                    a concludersi con una dichiarazione assolutamente inaspettata, 
                    da parte &#8211; guarda un po&#8217; &#8211; dello sconosciuto 
                    alla porta. Questi cinque racconti &#8211; sorretti da uno 
                    stile piano, descrittivo, maturo &#8211; sono tanto vicini 
                    ad una capacit&agrave; evocativa cinematografica (lo si ripeta: 
                    par di vederli i protagonisti e le protagoniste di queste 
                    pagine e non a caso Tamburini ha scritto anche per cinema 
                    e televisione) quanto lontani da una realt&agrave; artefatta 
                    ed artificiale. Ed &egrave; questa la forza del libro: regalarci 
                    un viaggio vero, possibile. Fatto da uomini cui la vita, all&#8217;improvviso, 
                    provoca un sussulto, un trasalimento, una sorpresa, una emozione, 
                    una seccatura. Uno dei racconti &#8211; non diremo quale &#8211; 
                    finisce con una descrizione assai efficace. &#8220;Dall&#8217;interno 
                    insieme all&#8217;impasto di voci proveniva un intenso alone 
                    luminoso e ho pensato che per chi si trovava sull&#8217;altra 
                    riva una delle luci specchiate dal lago era quella di casa 
                    mia&#8221;. In quella casa il lettore appagato &#8211; cos&igrave; 
                    ci &egrave; capitato &#8211; ha scorto lo scrittore intento 
                    al lavoro. Vent&#8217;anni dopo la sua luce, la luce di chi 
                    sa raccontare con amara dolcezza, brilla ancora. </p>
                  <p></p>
                  <p>STORIE DI VITE INCOMPRESE</p>
                  <p>Valeria Benincasa, www.romanoir.it</p>
                  <p>Le difficolt&agrave; e le incertezze 
                    della vita, come gli equilibri mentali decentrati da ricordi 
                    che tornano dal passato, sono alcuni dei temi dell'ultima 
                    raccolta di racconti di Alessandro Tamburini, Uno sconosciuto 
                    alla porta, in cui lo sconforto perenne e il vuoto esistenziale 
                    sono enfatizzati da una scrittura analitica e scenografica, 
                    non solo per la descrizione psicologica dei personaggi, ma 
                    soprattutto per l'ambientazione che circonda ogni racconto.<br/>
                    Le emozioni e gli stati d'animo vengono espressi con maestria 
                    da una punteggiatura non scarna ma essenziale, la quale scandisce 
                    il ritmo coinvolgente di ogni storia. I racconti, bench&eacute; 
                    diversi, sono tutti incentrati su decisioni esistenziali e 
                    attimi cruciali che fanno perennemente parte della vita di 
                    ognuno dei protagonisti, nei quali, per le loro fragilit&agrave; 
                    e per i loro attimi di smarrimento, spesso &egrave; facile 
                    identificarsi.<br/>
                    Nel terzo racconto, che d&agrave; il titolo al libro, l'unico 
                    brivido che si riesce a dare alla vita &egrave; la totale 
                    immersione in una catena di compravendite, che da semplice 
                    passatempo degenera in pura assuefazione, per arrivare a preoccupanti 
                    ed infide relazioni dalle quali &egrave; difficile, se non 
                    impossibile, districarsi. In questo caso l'imprevedibilit&agrave; 
                    e l'impotenza costringono il protagonista ad una repentina 
                    decisione di contrattacco che porter&agrave; successivamente 
                    a scoperte legate al passato ed all'infanzia, che consentiranno 
                    di scoprire che il presunto nemico non &egrave; stato altro 
                    che vittima inerme di avvenimenti che lo legheranno per sempre 
                    ad una condizione di precariet&agrave; ed insicurezza esistenziali.<br/>
                    Nel primo e nel secondo racconto, rispettivamente intitolati: 
                    &#8220;Brennero&#8221; e &#8220;Canzone&#8221;, sono i non-luoghi 
                    a farla da padrone; stazioni, treni, citt&agrave; fantasma 
                    e stanze frequentate da perfetti sconosciuti trasmettono il 
                    vuoto e lo spaesamento totali e nascosti da un anonimato quasi 
                    umiliante. Quando non si trova pi&ugrave; conforto neanche 
                    nella musica tanto vale affogare i propri pensieri nell'alcool 
                    fino a che neanche quest'ultimo consentir&agrave; pi&ugrave; 
                    di dimenticare le continue delusioni e sopraffazioni oltre 
                    che del mondo lavorativo anche della vita stessa.<br/>
                    Il quarto racconto &#8220;Prima che faccia giorno&#8221; &egrave; 
                    la storia di una vita, scandita da turni massacranti, trascorsa 
                    alla guida di un taxi perennemente frequentato da passeggeri 
                    psicoanalizzati. Languidi ricordi di amori passati che alimentano 
                    l'insoddisfazione di un presente privo di speranza, se non 
                    quella di riuscire a cambiare e forse un giorno potersi riscattare 
                    oltre che con il mondo proprio con se stessi.Torna, come in 
                    altri racconti, la tematica dell'alcool, unico mezzo di sostentamento 
                    morale, e della strada trafficata ed infinita nella quale 
                    perdersi per cercare di dimenticare la propria identit&agrave;.<br/>
                    Ricordi o allucinazioni che scandiscono ritmi veloci e attimi 
                    di suspance fino alla fine del racconto.<br/>
                    Il brano conclusivo, &#8220;La cura&#8221;, &egrave; scandito 
                    da una vuota e inutile libert&agrave; sovrastata dal desiderio 
                    di interrompere la deludente e insignificante vita attuale 
                    per ricominciarne una nuova. Sono pochi gli interessi e ancora 
                    meno gli argomenti di cui parlare con le persone perch&eacute; 
                    l'unica certezza &egrave; il solido e profondo rapporto con 
                    il tenero compagno di vita: Flint&#8230; il gatto.<br/>
                    L'unica soluzione all'eterna insoddisfazione personale &egrave; 
                    spostarsi e sparire dalla citt&agrave; per andare a vivere 
                    immersi in una rigogliosa e pittorica natura verdeggiante, 
                    nella quale, magari chiss&agrave;, poter ricominciare a vivere 
                    e respirare un nuovo sentimento che si tramuter&agrave; in 
                    amore.<br/>
                    Un'altra raccolta che si aggiunger&agrave; ai gi&agrave; numerosi 
                    successi di Tamburini, uno dei quali ottenuto proprio con 
                    la raccolta &#8220;Nel nostro primo mondo&#8221;, la seconda, 
                    che gli &egrave; valsa il &#8220;Premio Settembrini&#8221; 



                    o come il &#8220;Premio Grinzane Cavour&#8221; conquistato 
                    con il romanzo del 1997 &#8220;L'onore delle armi&#8221; e 
                    ancora prima il &#8220;Premio Sirmione-Catullo&#8221; del 

                    1992 per &#8220;Le luci del treno&#8221;.</p>
                </div>
                </div>
             </td>

          </tr>
        </table>
        <br/> <br/> <div > 
          <div > 
            <div> 
              <table border="0" cellpadding="0" cellspacing="2" width="300">
                <tr> 
                  <td> <div align="center">Tutti i diritti degli 
                      articoli della rassegna stampa pequodedizioni.it sono di 
                      propriet&agrave; dei rispettivi autori/testate/siti. I testi 
                      sono riprodotti unicamente a scopo informativo.</div></td>
                </tr>
              </table>
              <h1 ><br/>
              </h1>
            </div>
          </div>
        </div></td>
 <td width="300" height="10770" valign="top"></td>
    </tr>
  </table>
  <p></p>
		</div>









                        
                                                                                        <div class="modal-footer">
                                                                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                                                                                        </div>
                    </div>
                </div>
            </div>


                                                                            )
                                                                        }
                                                                    }
